/**
 * @module app.pp
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { ProviderPortalModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(ProviderPortalModule.registrationKey, ProviderPortalModule);

    config.globalResources([
        // elements

        // value converters
    ]);
}
